// src/config.js

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://localhost:4001";
const API_AUTH_URL = process.env.REACT_APP_API_AUTH_URL || "https://localhost:4000";

console.log("API_BASE_URL:", process.env.REACT_APP_API_BASE_URL);
console.log("API_AUTH_URL:", process.env.REACT_APP_API_AUTH_URL);
console.log("ENVIRONMENT:", process.env.NODE_ENV);

export const API_URLS = {
  // Updated branding endpoint now used for both front page and logo images.
  branding: id => `${API_BASE_URL}/api/content/${id}/branding`,
  // Updated questions endpoint to use URL parameter for businessId.
  questions: id => `${API_BASE_URL}/api/content/${id}/questions`,
  // Optionally added new referrals endpoint matching the contentRoutes
  referrals: id => `${API_BASE_URL}/api/content/${id}/referrals`,
  template: id => `${API_BASE_URL}/api/content/${id}/template`,
  token: `${API_AUTH_URL}/api/auth/token`,
  bulkData: id => `${API_BASE_URL}/api/feedback/${id}`,
  // Add more API endpoints here
};